import { ScrollLock } from './../../utils/scroll-lock.js';
import { FocusLock } from './../../utils/focus-lock.js';

const scrollLock = new ScrollLock();
const focusLock = new FocusLock();

// Функция для снятия фокуса с ссылок
const removeFocusFromLinks = (parent) => {
  if (!parent) {
    return;
  }
  const links = parent.querySelectorAll('.menu-category__link');
  links.forEach((link) => link.blur());
};

export const initMenuCategory = function() {
  const menuCategoryDropdown = document.querySelectorAll('[data-menu-category="item"]');
  const menuCategoryItem = document.querySelectorAll('[data-menu-category="list"] > li');
  if (menuCategoryDropdown.length > 0) {
    menuCategoryDropdown.forEach((item) => {
      const parent = item.closest('[data-menu-category="parent"]');
      const overlay = parent.querySelector('[data-menu-category="overlay"]');

      if (parent) {
        parent.addEventListener('mouseenter', () => {
          parent.classList.add('is-active');

          scrollLock.disableScrolling();
          focusLock.lock('[data-menu-category="parent"].is-active');
        });

        parent.addEventListener('mouseleave', () => {
          parent.classList.remove('is-active');
          scrollLock.enableScrolling();
          focusLock.unlock('[data-menu-category="parent"].is-active');
          removeFocusFromLinks(parent);
        });
      }

      if (overlay) {
        overlay.addEventListener('mouseenter', () => {
          if (parent.classList.contains('is-active')) {
            parent.classList.remove('is-active');
          }
        });
      }

      window.addEventListener('keydown', (e) => {
        if (e.keyCode === 27) {
          const parentOpen = document.querySelector('[data-menu-category="parent"].is-active');
          if (parentOpen) {
            parentOpen.classList.remove('is-active');
          }
        }
      }, true);
    });
  }

  if (menuCategoryItem.length > 0) {
    menuCategoryItem.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        if (!item.classList.contains('is-active')) {
          const activeParent = document.querySelector('[data-menu-category="parent"].is-active');

          if (activeParent) {
            scrollLock.enableScrolling();
            focusLock.unlock('[data-menu-category="parent"].is-active');
            activeParent.classList.remove('is-active');
            removeFocusFromLinks(activeParent);
          }
        }
      });
    });
  }
};
